import { render, staticRenderFns } from "./prodDialog.vue?vue&type=template&id=cbf8f052&scoped=true"
import script from "./prodDialog.vue?vue&type=script&lang=js"
export * from "./prodDialog.vue?vue&type=script&lang=js"
import style0 from "./prodDialog.vue?vue&type=style&index=0&id=cbf8f052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf8f052",
  null
  
)

export default component.exports